// extracted by mini-css-extract-plugin
module.exports = {"sender-fancy-scrollbar":"styles_sender-fancy-scrollbar___L_Qk","sender-editor":"styles_sender-editor__asS6B","tiptap-wrapper":"styles_tiptap-wrapper__ub8y_"};